import { RootState } from '@/shared/types/state';

export const selectSidebarPanelConfig = (state: RootState) => state.uiConfig.resizable.sidebarPanel;
export const selectToastEnabled = (state: RootState) => state.uiConfig.showToasts;
